import {
  PrescriptionSeverity,
  PrescriptionStatus,
  PrescriptionStatusChipSeverityMapper,
  PrescriptionStatusMapper,
} from "@interfaces/Prescription";
import { styled, Chip, lighten } from "@mui/material";

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop: string) => prop !== "severity",
})<{ severity: PrescriptionSeverity }>(({ theme, severity }) => ({
  fontWeight: 600,
  backgroundColor:
    severity === "info"
      ? lighten(theme.palette[severity].main, 0.9)
      : lighten(theme.palette[severity].light, 0.9),
  color: theme.palette[severity].main,
}));

type Props = {
  status: PrescriptionStatus;
};

export const PrescriptionStatusLabel = ({ status }: Props) => {
  return (
    <StyledChip
      size="small"
      label={PrescriptionStatusMapper[status]}
      severity={PrescriptionStatusChipSeverityMapper[status]}
    />
  );
};
